import { render, staticRenderFns } from "./WorkflowFormDetailPage.vue?vue&type=template&id=0649d89a&"
import script from "./WorkflowFormDetailPage.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormDetailPage.vue?vue&type=style&index=0&id=0649d89a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports